import styles from "./styles.module.scss";
import { SearchMagnify } from "common/icons";
import { Icon } from "core/components/icon/Icon";

export const Search = () => (
    <Icon size="small" className={styles.strokeOnly}>
        <SearchMagnify />
    </Icon>
);
